import dayjs from "dayjs";
import CryptoJS from "crypto-js";

/** ================== 工具函数 ================== */

// 日期格式化
export const dateFormat = (date, format = "YYYY-MM-DD HH:mm:ss") => {
  return dayjs(date).format(format);
};

// 时间差 mm:ss
export const dateDiff = (startDate, endDate) => {
  const diff = dayjs(endDate).diff(dayjs(startDate));

  const minutes = Math.floor(diff / 60000);
  const seconds = Math.floor((diff % 60000) / 1000);

  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
    2,
    "0",
  )}`;
};

// MD5
export const getMD5 = (str) => CryptoJS.MD5(str).toString();

export {
  enableExamGuard,
  disableExamGuard,
  requestFullscreen,
  isFullscreen,
  exitFullscreenSafe,
  tryEnterFullscreenFromUserGesture,
} from "./examGuard/index.js";
